import { useMemo } from 'react';
import { FlexCol } from '@/UI/styles';
import { useWorkflowStore } from '@/state/workflow.state';
import NodeDataCard from '@/components/Common/NodeDataCard/NodeDataCard';
import AppDivider from '@/UI/AppDivider/AppDivider';

interface ModelDetailsProps {
  description: string;
  modelName: string;
  modelType?: string;
  price?: number;
  isByok?: boolean;
}

export const ModelDetails = ({ description, modelName, modelType, price, isByok }: ModelDetailsProps) => {
  const nodeTypes = useWorkflowStore((state) => state.nodeTypes);

  const metadata = useMemo(() => {
    if (!modelType) {
      return null;
    }
    const nodeDef = nodeTypes.find((nodeType) => nodeType.data?.model?.name === modelType);
    return nodeDef?.metadata;
  }, [modelType, nodeTypes]);

  return (
    <FlexCol>
      <NodeDataCard
        displayName={modelName}
        description={description}
        price={price}
        isByok={isByok}
        isVerified={!!metadata?.isVerified}
        termsUrls={metadata?.termsUrls}
        privacyUrl={metadata?.privacyPolicyUrl}
        inputTypes={metadata?.inputTypes}
        outputTypes={metadata?.outputTypes}
        pt={1.5}
        px={1.5}
      />
      <AppDivider />
    </FlexCol>
  );
};
